import React from 'react';
import { NavLink } from 'react-router-dom';
import { companyDetails } from '../../data/siteData';

class AboutSection extends React.Component {
    render() {
        const showButton = this.props.showButton !== undefined ? this.props.showButton : true;

        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b80 bg-gray">
                    <div className="container">
                        <div className="section-content">
                            <div className="row align-items-center">
                                <div className="col-xl-5 col-lg-5 col-md-12 m-b30 wow fadeInLeft" data-wow-duration="1.2s" data-wow-delay="0.1s">
                                    <div style={{ borderRadius: '10px', overflow: 'hidden', height: '320px', boxShadow: '0 8px 25px rgba(0,0,0,0.08)' }}>
                                        <img src={require('./../../images/products/acp_cladding.jpg')} alt="bs clads Architectural Elevations" className="wow zoomIn" data-wow-duration="1.4s" data-wow-delay="0.2s" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                </div>
                                <div className="col-xl-7 col-lg-7 col-md-12">
                                    <div className="about-home-2 p-l20">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                                            <span style={{ color: '#E85B24', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', fontSize: '13px' }}>
                                                ESTABLISHED IN 2010
                                            </span>
                                            <span style={{
                                                backgroundColor: '#f03a02',
                                                color: '#ffffff',
                                                padding: '4px 12px',
                                                borderRadius: '20px',
                                                fontSize: '11px',
                                                fontWeight: '800',
                                                letterSpacing: '1px',
                                                textTransform: 'uppercase',
                                                boxShadow: '0 2px 8px rgba(240, 58, 2, 0.3)'
                                            }}>
                                                <i className="fa fa-star m-r5" /> QUALITY FIRST
                                            </span>
                                        </div>

                                        <h3 className="m-t0 sx-tilte wow fadeInRight" data-wow-duration="1s" data-wow-delay="0.2s" style={{ fontWeight: '800' }}>
                                            {companyDetails.name} — Premier Architectural Facades
                                        </h3>
                                        <p className="wow fadeInRight" data-wow-duration="1s" data-wow-delay="0.3s" style={{ color: '#555', fontSize: '15px', lineHeight: '1.8', textAlign: 'justify' }}>
                                            Since 2010, <strong>{companyDetails.name}</strong> has provided high-performance ACP Front Elevation, Facade Glazing, wall cladding, and toughened glass structural elevation solutions across Coimbatore and Tamil Nadu with uncompromised architectural precision.
                                        </p>

                                        {/* PROMINENT QUALITY HIGHLIGHT BOX */}
                                        <div className="wow fadeInUp quality-highlight-card" data-wow-duration="1s" data-wow-delay="0.35s" style={{
                                            backgroundColor: '#ffffff',
                                            borderLeft: '5px solid #f03a02',
                                            padding: '18px 22px',
                                            borderRadius: '0 12px 12px 0',
                                            marginTop: '22px',
                                            boxShadow: '0 8px 25px rgba(0,0,0,0.06)'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                                <i className="fa fa-certificate" style={{ color: '#f03a02', fontSize: '24px', flexShrink: 0 }} />
                                                <h4 className="quality-headline-text" style={{ margin: 0, fontWeight: '800', fontSize: '17px', color: '#111111', letterSpacing: '0.5px' }}>
                                                    <span>WORLD-CLASS </span>
                                                    <span style={{ color: '#f03a02', backgroundColor: 'rgba(240, 58, 2, 0.08)', padding: '2px 8px', borderRadius: '4px', margin: '0 4px' }}>QUALITY</span>
                                                    <span className="quality-word-guaranteed"> GUARANTEED</span>
                                                </h4>
                                            </div>
                                            <p style={{ margin: '10px 0 0 0', fontSize: '13.5px', color: '#444', lineHeight: '1.6' }}>
                                                At {companyDetails.name}, <strong>Quality</strong> is our top priority. We source only certified ACP sheets, toughened safety glass, and genuine accessories for long-lasting structural excellence.
                                            </p>
                                        </div>

                                        {showButton && (
                                            <div className="text-left m-t25 wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s">
                                                <NavLink to={"/about-us"} className="site-button btn-half" style={{ backgroundColor: '#f03a02', border: 'none' }}>
                                                    <span>Read More</span>
                                                </NavLink>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AboutSection;
